import useDeviceType from "../utils/useDeviceType"

export function useFormattedOperatingHours(operatingHours) {
  const { isMobile } = useDeviceType()

  if (!operatingHours) return "No operating hours available"

  const openDays = Object.entries(operatingHours)
    .filter(([_, value]) => value.is_open)
    .map(([day, value]) => ({
      day,
      open: value.open,
      close: value.close,
    }))

  if (openDays.length === 0) return "Closed all week"

  const dayNames = isMobile
    ? {
        monday: "Mon",
        tuesday: "Tue",
        wednesday: "Wed",
        thursday: "Thu",
        friday: "Fri",
        saturday: "Sat",
        sunday: "Sun",
      }
    : {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      }

  const firstDay = dayNames[openDays[0].day]
  const lastDay = dayNames[openDays[openDays.length - 1].day]

  const formatTime = (timeStr) => {
    const [h, m] = timeStr.split(":").map(Number)
    const period = h >= 12 ? "PM" : "AM"
    const hour12 = ((h + 11) % 12) + 1
    return `${hour12}:${m.toString().padStart(2, "0")} ${period}`
  }

  const openTime = openDays[0].open
  const closeTime = openDays[0].close

  return `Opens ${firstDay} – ${lastDay}, ${formatTime(
    openTime
  )} – ${formatTime(closeTime)}`
}
